import { render, staticRenderFns } from "./SurveyGeneral.vue?vue&type=template&id=1bfcb14c"
import script from "./SurveyGeneral.vue?vue&type=script&lang=js"
export * from "./SurveyGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports